import React, { Component } from "react";

class SectionColumn extends Component {


   



    

    render() {
        let eachColumnWidth = this.props.sectionWidth;
        let eachColumnHeight = this.props.sectionHeight;
        let sampleDivs = this.props.sampleDivs;
        return (
            <div
                onClick={this.props.setSelectedColSpan}
                className="column__model"
                style={{
                    cursor: "pointer",
                    margin: 4,
                    minHeight: 50,
                    flex: "0 1 calc(16% - 8px)",
                    display: "flex",
                    columnGap: '5%'
                }}
                >
                {sampleDivs.map((flex, index) => {
                    return (
                        <div
                        style={{
                                // background: "rgb(104, 99, 99)",
                                backgroundColor: "rgb(104, 99, 99)",
                                borderRadius: 0.5,
                                flex: flex,
                            }}
                            key={index}
                        ></div>
                    );
                })}
            </div>
        );
    }
}

export default SectionColumn;
